"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useGameBridge_1 = require("./useGameBridge");
function useDeferredQueryData(channel, id) {
    const gameBridge = (0, useGameBridge_1.default)();
    const [data, setData] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const query = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        try {
            const result = yield gameBridge.queryAsync(channel, id);
            setData(result);
            return result;
        }
        catch (err) {
            setError(err);
            return null;
        }
        finally {
            setLoading(false);
        }
    }), [gameBridge, channel, id]);
    return [data, query, loading, error];
}
exports.default = useDeferredQueryData;
